/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, ClickAwayListener, Grow, MenuList, Paper, Popper } from "__barrel_optimize__?names=Box,ClickAwayListener,Grow,MenuList,Paper,Popper!=!@mui/material";
import Link from 'next/link';
const resourceLinks = [
    {
        name: 'How It Works',
        href: '/how-it-works'
    },
    {
        name: 'Dealer Referral Program',
        href: '/dealer-referral-program'
    },
    {
        name: 'Blog',
        href: '/blog'
    },
    {
        name: 'Help Center',
        href: '/help-center'
    },
    {
        name: 'Contact Us',
        href: '/contact-us'
    }
];
function ResourcesDropdown() {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const handleListKeyDown = (event)=>{
        if (event.key === 'Escape') {
            var _anchorRef_current;
            event.preventDefault();
            setOpen(false);
            (_anchorRef_current = anchorRef.current) === null || _anchorRef_current === void 0 ? void 0 : _anchorRef_current.focus();
        }
    };
    const openMenu = ()=>setOpen(true);
    const closeMenu = ()=>setOpen(false);
    const anchorReady = Boolean(anchorRef.current);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("button", {
                className: "flex text-neutral-600 text-sm font-medium",
                id: "products-menu-button",
                "aria-haspopup": "menu",
                "aria-expanded": open ? 'true' : undefined,
                "aria-controls": open ? 'mega-menu-products' : undefined,
                ref: anchorRef,
                onMouseEnter: openMenu,
                onFocus: openMenu,
                onClick: ()=>setOpen((o)=>!o),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-2",
                        children: "Resources"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.3s',
                            transformOrigin: 'center center'
                        },
                        children: /*#__PURE__*/ _jsx("i", {
                            className: "bi bi-chevron-down"
                        })
                    })
                ]
            }),
            anchorReady && /*#__PURE__*/ _jsx(Popper, {
                id: "resources-menu-products",
                open: open,
                anchorEl: anchorRef.current,
                placement: "bottom-start",
                transition: true,
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [
                                0,
                                14
                            ]
                        }
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            boundary: 'viewport'
                        }
                    }
                ],
                sx: {
                    zIndex: (t)=>t.zIndex.appBar + 1,
                    left: 0,
                    right: 0,
                    width: '100vw'
                },
                children: (param)=>{
                    let { TransitionProps } = param;
                    return /*#__PURE__*/ _jsx(Grow, {
                        ...TransitionProps,
                        style: {
                            transformOrigin: 'top left'
                        },
                        children: /*#__PURE__*/ _jsx(Paper, {
                            elevation: 4,
                            onMouseLeave: closeMenu,
                            sx: {
                                borderBottomLeftRadius: 16,
                                borderBottomRightRadius: 16,
                                overflow: 'hidden',
                                boxShadow: 'none'
                            },
                            children: /*#__PURE__*/ _jsx(ClickAwayListener, {
                                onClickAway: ()=>setOpen(false),
                                children: /*#__PURE__*/ _jsx(MenuList, {
                                    onMouseLeave: closeMenu,
                                    onKeyDown: handleListKeyDown,
                                    // Use a Box wrapper to grid the content while keeping MenuList semantics.
                                    sx: {
                                        px: 3,
                                        pt: 4,
                                        pb: 3,
                                        width: '100vw'
                                    },
                                    children: /*#__PURE__*/ _jsxs(Box, {
                                        role: "group",
                                        "aria-label": "Resources mega menu",
                                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-20 max-w-6xl mx-auto",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("p", {
                                                    className: "text-lg",
                                                    children: "Get the most out of AutoVINsights."
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col border-l border-neutral-300 px-10",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-4",
                                                        children: /*#__PURE__*/ _jsx("span", {
                                                            className: "text-neutral-500 text-sm font-medium",
                                                            children: "Resources"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "flex flex-col gap-1",
                                                        children: resourceLinks.map((link, index)=>/*#__PURE__*/ _jsx(Link, {
                                                                href: link.href,
                                                                className: "hover:bg-cyan/50 rounded-md font-medium px-4 py-2",
                                                                children: link.name
                                                            }, index))
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    });
                }
            })
        ]
    });
}
export default ResourcesDropdown;
